/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataSurveyShape } from './DataSurveyShape';
import {
    DataSurveyShapeFromJSON,
    DataSurveyShapeFromJSONTyped,
    DataSurveyShapeToJSON,
    DataSurveyShapeToJSONTyped,
} from './DataSurveyShape';
import type { DataSurveyTypeEnum } from './DataSurveyTypeEnum';
import {
    DataSurveyTypeEnumFromJSON,
    DataSurveyTypeEnumFromJSONTyped,
    DataSurveyTypeEnumToJSON,
    DataSurveyTypeEnumToJSONTyped,
} from './DataSurveyTypeEnum';
import type { DataPointHistoryLocation } from './DataPointHistoryLocation';
import {
    DataPointHistoryLocationFromJSON,
    DataPointHistoryLocationFromJSONTyped,
    DataPointHistoryLocationToJSON,
    DataPointHistoryLocationToJSONTyped,
} from './DataPointHistoryLocation';

/**
 * Serializer for `DataSurvey` records.
 * @export
 * @interface DataSurvey
 */
export interface DataSurvey {
    /**
     * 
     * @type {string}
     * @memberof DataSurvey
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof DataSurvey
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof DataSurvey
     */
    startDatetime: Date;
    /**
     * 
     * @type {Date}
     * @memberof DataSurvey
     */
    endDatetime: Date;
    /**
     * 
     * @type {DataSurveyTypeEnum}
     * @memberof DataSurvey
     */
    dataType: DataSurveyTypeEnum;
    /**
     * 
     * @type {DataPointHistoryLocation}
     * @memberof DataSurvey
     */
    location: DataPointHistoryLocation;
    /**
     * 
     * @type {DataSurveyShape}
     * @memberof DataSurvey
     */
    shape?: DataSurveyShape | null;
}



/**
 * Check if a given object implements the DataSurvey interface.
 */
export function instanceOfDataSurvey(value: object): value is DataSurvey {
    if (!('id' in value) || value['id'] === undefined) return false;
    if ((!('startDatetime' in (value as Record<string, any>)) && !('start_datetime' in (value as Record<string, any>))) || ((value as Record<string, any>)['startDatetime'] === undefined && (value as Record<string, any>)['start_datetime'] === undefined)) return false;
    if ((!('endDatetime' in (value as Record<string, any>)) && !('end_datetime' in (value as Record<string, any>))) || ((value as Record<string, any>)['endDatetime'] === undefined && (value as Record<string, any>)['end_datetime'] === undefined)) return false;
    if ((!('dataType' in (value as Record<string, any>)) && !('data_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['dataType'] === undefined && (value as Record<string, any>)['data_type'] === undefined)) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    return true;
}

export function DataSurveyFromJSON(json: any): DataSurvey {
    return DataSurveyFromJSONTyped(json, false);
}

export function DataSurveyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataSurvey {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'startDatetime': (new Date(json['start_datetime'])),
        'endDatetime': (new Date(json['end_datetime'])),
        'dataType': DataSurveyTypeEnumFromJSON(json['data_type']),
        'location': DataPointHistoryLocationFromJSON(json['location']),
        'shape': json['shape'] === undefined ? undefined : json['shape'] === null ? null : DataSurveyShapeFromJSON(json['shape']),
    };
}

export function DataSurveyToJSON(json: any): DataSurvey {
    return DataSurveyToJSONTyped(json, false);
}

export function DataSurveyToJSONTyped(value?: Omit<DataSurvey, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'start_datetime': value['startDatetime'].toISOString(),
        'end_datetime': value['endDatetime'].toISOString(),
        'data_type': DataSurveyTypeEnumToJSON(value['dataType']),
        'location': DataPointHistoryLocationToJSON(value['location']),
        'shape': DataSurveyShapeToJSON(value['shape']),
    };
}

